import React from 'react';
import PropTypes from 'prop-types';

const CIDPagination = ({
  currentPage,
  totalResults,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => {
  // Garante que o totalPages seja ao menos 1
  const totalPages = Math.max(Math.ceil(totalResults / pageSize), 1);

  return (
    <div className="flex flex-col md:flex-row justify-between items-center p-4 bg-white border border-gray-200 rounded-lg w-full space-y-4 md:space-y-0 md:space-x-4">
      {/* Botões de navegação */}
      <div className="flex items-center space-x-4">
        <button
          aria-label="Página anterior"
          className={`px-4 py-2 rounded-3xl transition-all duration-300 ${
            currentPage === 1
              ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
              : 'bg-green-500 text-white hover:bg-green-600 focus:ring-2 focus:ring-green-600 focus:outline-none'
          }`}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Anterior
        </button>

        <span className="text-gray-700 font-medium">
          Página {currentPage} de {totalPages}
        </span>

        <button
          aria-label="Próxima página"
          className={`px-4 py-2 rounded-3xl transition-all duration-300 ${
            currentPage === totalPages
              ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
              : 'bg-green-500 text-white hover:bg-green-600 focus:ring-2 focus:ring-green-600 focus:outline-none'
          }`}
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
          disabled={currentPage === totalPages}
        >
          Próxima
        </button>
      </div>

      {/* Seletor de itens por página */}
      <div className="flex items-center space-x-2">
        <span className="text-gray-600">Itens por página:</span>
        <select
          aria-label="Selecione o número de itens por página"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="border border-gray-300 rounded-md p-2 pr-8 focus:ring-green-600 focus:outline-none transition duration-300"
        >
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
        </select>
      </div>
    </div>
  );
};

CIDPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
};

export default CIDPagination;
